import React, { useMemo, useState } from "react";
import {
    Table,
    Button,
    Collapse,
    Offcanvas,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import { FaQuestionCircle } from 'react-icons/fa'; // Example using FontAwesome

import './PCtableTmpl.css'

export default function ParentChildTable({
    data = [],
    parentColumns = [],
    childColumns = [],
    parentColumnGroups = [],
    parentKey = "id",
    childKey = "id",
    childrenField = "children",
    parentNameField = "name",
    childNameField = "name",
    renderParentDetails,
    renderChildDetails,
    handleSort,
    sortConfig,

    deleteParentScheme,
    selectSubstituteChild,
    deleteSubstituteChild,
    showChildHeader="auto",  // "auto", true, false
    context=null,
}) {

    const [expanded, setExpanded] = useState({});
    const [selectedParent, setSelectedParent] = useState(null);
    const [selectedChild, setSelectedChild] = useState(null);

    const toggle = (id) => {
        setExpanded(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const columnsAreSame = (parentColumns, childColumns) => {
        if (parentColumns.length !== childColumns.length) return false;

        return parentColumns.every((p, index) => {
            const c = childColumns[index];
            return (
                p.field === c.field &&
                (p.label || p.title) === (c.label || c.title)
            );
        });
    };

    const shouldShowChildHeader =
        showChildHeader === true ||
        (showChildHeader === "auto" && !columnsAreSame(parentColumns, childColumns));

    const SortIndicator = ({ field }) => {
        if (sortConfig.field !== field) {
            return (
                <span className="sort-indicator text-muted">
                    ↕
                </span>
            );
        }

        return sortConfig.direction === "asc" ? (
            <span className="sort-indicator">↑</span>
        ) : (
            <span className="sort-indicator">↓</span>
        );
    };
    const TooltipIndicator = ({ field }) => {

        return (
            <span className="tooltip-indicator text-muted">
                <FaQuestionCircle /> {/* &#9432; Information character ℹ or use '?' */}
            </span>
        );

    };

    const hasColumnGroups = useMemo(() => {
        if (!parentColumnGroups || parentColumnGroups.length === 0) return false;

        const totalSpan = parentColumnGroups.reduce(
            (sum, group) => sum + group.span,
            0
        );

        return totalSpan === parentColumns.length;
    }, [parentColumnGroups, parentColumns]);

    return (
        <>
            <Table bordered hover responsive="md" size="sm" style={{fontSize:'0.85rem'}} className="parent-child-table" >
                <colgroup>
                    {/* Expand / indent column */}
                    <col style={{ width: "30px" }} />

                    {/* Parent data columns */}
                    {parentColumns.map((col) => (
                        <col
                            key={col.field}
                            style={{ width: col.width || "60px" }}
                        />
                    ))}

                    {/* Action and status columns */}
                    <col style={{ width: "40px" }} />
                    <col style={{ width: "40px" }} />
                </colgroup>
                <thead>
                    {hasColumnGroups && (
                        <tr className="parent-group-header-row">
                            <th className="expand-cell group-spacer"></th>

                            { /* style={group.width ? { width: group.width }: { }} */
                            parentColumnGroups.map((group, index) => (
                                <th
                                    key={index}
                                    colSpan={group.span}
                                    className="parent-group-header-cell"
                                >
                                    {group.label}
                                </th>
                            ))}

                            <th className="parent-group-header-cell"
                                colSpan={2}>
                                Actions
                            </th>
                        </tr>
                    )}
                    <tr className="parent-header-row">
                        <th className="expand-cell"></th>
                        { /* th style={{ width: col.width }} */
                          parentColumns.map((col) => (
                            <th
                                key={col.field}
                                className={
                                    col.sortable
                                        ? "parent-cell sortable-header"
                                        : "parent-cell"
                                }
                                onClick={() =>
                                    col.sortable && handleSort(col.field)
                                }
                            >
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-${col.field}`}>
                                            {col.tooltip || col.label2 }
                                        </Tooltip>
                                    }
                                >
                                    <div className="header-content">
                                        <span>{hasColumnGroups ? col.label : col.label2}</span>

                                        {col.sortable && (
                                            <SortIndicator field={col.field} />
                                        )}
                                        {col.tooltip && (<TooltipIndicator />)}
                                    </div>
                                </OverlayTrigger>
                            </th>
                        ))}
                       <th className="action-header-cell">
                            Action-1
                        </th>
                       <th className="action-header-cell">
                            Action-2
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((parent) => (
                            <React.Fragment key={parent.ParentWatchlistScheme[parentKey]}>
                                <tr className="parent-row">
                                    <td className="expand-cell">
                                        {
                                            parent[childrenField]?.length > 0 ?
                                                <Button
                                                    size="md"
                                                    variant="outline-info"
                                                    className="fw-bold"
                                                    onClick={() => toggle(parent.ParentWatchlistScheme[parentKey])}
                                                >
                                                    {
                                                        expanded[parent.ParentWatchlistScheme[parentKey]] ?
                                                            "-" : "+"
                                                    }
                                                </Button>
                                                : null
                                        }
                                    </td>
                                    { /* td style={{ width: col.width }} */ 
                                        parentColumns.map(col => ( 
                                            <td key={col.field} 
                                            
                                                className={
                                                    col.field === parentNameField
                                                        ? "parent-name-cell text-start"
                                                        : "parent-cell"
                                                }
                                            >
                                                {
                                                    col.field === parentNameField ?
                                                        <Button
                                                            variant="link"
                                                            className="p-0 text-start"
                                                            onClick={() => setSelectedParent(parent)}
                                                        >
                                                            {parent.ParentWatchlistScheme[col.field]}
                                                        </Button>
                                                        :
                                                        parent.ParentWatchlistScheme[col.field]
                                                }
                                            </td>
                                        ))
                                    }
                                    <td className="parent-option-cell"/>
                                    <td className="parent-option-cell">
                                        <Button
                                            size="sm"
                                            className="text-wrap"
                                            style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}
                                            variant="light"
                                            onClick={(e) => deleteParentScheme(e, context, parent.ParentWatchlistScheme[parentKey])}
                                        >
                                            Remove
                                        </Button>
                                    </td>

                                </tr>

                                {expanded[parent.ParentWatchlistScheme[parentKey]] &&
                                    shouldShowChildHeader && (
                                        <tr className="child-header-row">
                                            <th className="child-indent-header" />
                                            { /* th style={{ width: parentCol.width }} */
                                                parentColumns.map((parentCol) => {
                                                    const childCol = childColumns.find(
                                                        c => c.field === parentCol.field
                                                    );
                                                    return ( 
                                                        <th key={childCol.field}
                                                           
                                                            className="child-header-cell">
                                                            {hasColumnGroups ? childCol.label : childCol.label2}
                                                        </th>
                                                    )
                                                }
                                                )
                                            }
                                            <th className="action-header-cell">
                                                Action-1
                                            </th>
                                            <th className="action-header-cell">
                                                Action-2
                                            </th>
                                        </tr>
                                    )
                                }
                                {
                                    expanded[parent.ParentWatchlistScheme[parentKey]] &&
                                    parent[childrenField].map((child) => (
                                        <tr key={child[childKey]} className="child-row">
                                            <td className="child-indent"> </td>
                                            {  /* td style={{ width: parentCol.width }} */
                                                parentColumns.map((parentCol) => {
                                                    const childCol = childColumns.find(
                                                        c => c.field === parentCol.field
                                                    );
                                                    return (
                                                        <td key={parentCol.field}
                                                            
                                                            className={
                                                                childCol &&
                                                                    (childCol.field === childNameField)
                                                                    ? "child-name-cell text-start"
                                                                    : "child-cell"
                                                            }
                                                        >
                                                            {
                                                                childCol ? (
                                                                    childCol.field === childNameField ?
                                                                        <Button
                                                                            variant="link"
                                                                            className="p-0 text-start"
                                                                            onClick={() => setSelectedChild(child)}
                                                                        >
                                                                            {child[childCol.field]}
                                                                        </Button>
                                                                        :
                                                                        child[childCol.field]
                                                                ) : null
                                                            }
                                                        </td>
                                                    )
                                                })
                                            }
                                            <td className="child-option-cell p-1">
                                                <div className="d-flex flex-wrap gap-1">
                                                    <Button
                                                        size="sm"
                                                        className="text-wrap"
                                                        style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}
                                                        variant="outline-success"
                                                        onClick={(e) => selectSubstituteChild(e, context, parent.ParentWatchlistScheme[parentKey], child[childKey])}

                                                    >
                                                        Substitute
                                                    </Button>
                                                </div>
                                            </td>
                                            <td className="child-option-cell p-1">
                                                <div className="d-grid d-md-block">
                                                    <Button
                                                        size="sm"
                                                        className="btn-custom-lightRed text-wrap" 
                                                        style={{ whiteSpace: 'normal', wordBreak: 'break-word', width: '100%' }}
                                                        variant="outline-secondary"
                                                        onClick={(e) => deleteSubstituteChild(e, context, parent.ParentWatchlistScheme[parentKey], child[childKey])}
                                                    >
                                                        Remove
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </React.Fragment>
                        ))
                    }
                </tbody>
            </Table>

            <Offcanvas
                placement="end"
                show={selectedParent != null}
                onHide={() => setSelectedParent(null)}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Parent Details
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        selectedParent &&
                        renderParentDetails(selectedParent.ParentWatchlistScheme)
                    }
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas
                placement="end"
                show={selectedChild != null}
                onHide={() => setSelectedChild(null)}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        Child Details
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        selectedChild &&
                        renderChildDetails(selectedChild)
                    }
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}